<template>
<div>
<div v-if="lang == 'he'" class="inhonorof inhonorof--heb">
	<FormRow>
  		<input type="checkbox" id="inHonorOf" name="inHonorOf" v-model="inHonorOf"/>
  		<FormLabel for="inHonorOf">הקדש את התרומה שלך</FormLabel>
	</FormRow>
	<div  v-if="inHonorOf" class="honor-container">
		<FormRow inline>
			<FormCol field="dedication">
				 <FormSelect>
				<option value="In honor of">לכבוד</option>
				<option value="In memory of">לזכר</option>
				<option value="For the recovery of">להחלמה של</option>
				</FormSelect>
			</FormCol>
			<FormCol field="honoreeName" />
		</FormRow>
		<FormRow inline>
			<FormCol field="dedicationMessage" />
		</FormRow>
		<FormRow inline v-if="recipientFlag">
			<FormCol field="recipientName" />
			<FormCol field="recipientEmail" />
		</FormRow>
		<FormRow inline v-if="recipent">
			<span class="edit-recipient" @click="()=>{recipientFlag = !recipientFlag}">
				<span v-if="!recipientFlag">+ לְהוֹסִיף </span>
				<span v-else>- להסיר </span>
				מקבל
				<span v-if="!recipientFlag">  להודיע</span>
			</span>
		</FormRow>
	</div>
</div>
<div class="inhonorof" v-else>
	<FormRow>
  		<input type="checkbox" id="inHonorOf" name="inHonorOf" v-model="inHonorOf"/>
  		<FormLabel for="inHonorOf">{{ dedicateLabel }}</FormLabel>
	</FormRow>
	<div  v-if="inHonorOf" class="honor-container">
		<FormRow inline>
			<FormCol field="dedication">
				<FormSelect>
				<option value="In honor of">In honor of</option>
				<option value="In memory of">In memory of</option>
				<option value="For the recovery of">For the recovery of</option>
				</FormSelect>
			</FormCol>
			<FormCol field="honoreeName" />
		</FormRow>
		<FormRow inline>
			<FormCol field="dedicationMessage" />
		</FormRow>
		<FormRow inline v-if="recipientFlag">
			<FormCol field="recipientName" />
			<FormCol field="recipientEmail" />
		</FormRow>
		<FormRow inline v-if="recipent">
			<span class="edit-recipient" @click="()=>{recipientFlag = !recipientFlag}">
				<span v-if="!recipientFlag">+ Add </span>
				<span v-else>- Remove </span>
				recipient
				<span v-if="!recipientFlag"> to notify</span>
			</span>
		</FormRow>
	</div>
</div>
</div>
</template>
<script lang="ts">
import { defineComponent,  ref, watch } from 'vue'

export default defineComponent({
  props: {
    recipent: {
      type: Boolean,
      default: true
    },
		lang: {
      type: String
    },
    initialOpen: {
      type: Boolean,
      default: false
    },
    dedicateLabel: {
      type: String,
      default: 'Dedicate your donation'
    },
  },
  setup(props) {
	  const inHonorOf = ref(props.initialOpen)
	  const recipientFlag = ref(false)

	  return {
		  inHonorOf,
		  recipientFlag
	  }
  }
})
</script>
<style scoped lang="scss">
input[type="checkbox"] {
	margin-right: 7px;
}
.honor-container {
	padding-top: 20px;
	border-top: 1px solid #ddd;
	margin-top: 20px;
}
.flex {
	display: flex;
	align-items: center;
}
.honor-type {
	max-width: 150px;
	min-width: 150px;
	margin-right: 7px;
}
.edit-recipient {
	color: $color-blue;
	font-size: 13px;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}

}
::v-deep .inhonorof--heb{
	label[for="inHonorOf"]:after {content:"הקדש את התרומה שלך";}
	label[for="dedication"]:after {content:"הקדשׁה";}
	label[for="recipientName"]:after {content:"שם הנמען";}
	label[for="recipientEmail"]:after {content:"אימייל של נמען ";}
	label[for="honoreeName"]:after {content:"שם המכובד";}
	label[for="dedicationMessage"]:after {content:" הודעת הקדשה";}

}
</style>
